/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createProblemDetailsFromDiscriminatorValue, serializeConvertCustomerToConsumerCommand, type ConvertCustomerToConsumerCommand, type ProblemDetails } from '../../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /customers/{customer-id}/consumer-conversion
 */
export interface ConsumerConversionRequestBuilder extends BaseRequestBuilder<ConsumerConversionRequestBuilder> {
    /**
     * ConvertCustomerToConsumer
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @throws {ProblemDetails} error when the service returns a 400 status code
     * @throws {ProblemDetails} error when the service returns a 404 status code
     * @throws {ProblemDetails} error when the service returns a 409 status code
     */
     post(body: ConvertCustomerToConsumerCommand, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<void>;
    /**
     * ConvertCustomerToConsumer
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPostRequestInformation(body: ConvertCustomerToConsumerCommand, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const ConsumerConversionRequestBuilderUriTemplate = "{+baseurl}/customers/{customer%2Did}/consumer-conversion";
/**
 * Metadata for all the requests in the request builder.
 */
export const ConsumerConversionRequestBuilderRequestsMetadata: RequestsMetadata = {
    post: {
        uriTemplate: ConsumerConversionRequestBuilderUriTemplate,
        responseBodyContentType: "application/problem+json",
        errorMappings: {
            400: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            404: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            409: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "sendNoResponseContent",
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeConvertCustomerToConsumerCommand,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
